import React from "react";
import "./home.page.styles.scss";

const HomePage = () => {
  return (
    <div className="homepage-container" id="homepage">
      <div className="hero">
        <div className="homepage-title">
          <div className="box-shadow">
            <h1 className="homepage-name ">LuPo</h1>
            <h1 className="homepage-subtitle ">Photography</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
